<template>
<div class="receive-coupon">
  <van-popup v-model="selectShow" :overlay="false" class="popup" position="bottom">
    <van-picker ref="picker" show-toolbar cancel-button-text=" " @confirm="receiveCoupon" defaultIndex="0" :columns="serialList" value-key="name" @change="onChangeSelect" />
  </van-popup>
  <van-popup v-model="showPopup" class="popup" :class="selectShow?'receive-popup':''" :close-on-click-overlay="false" @click-overlay="selectShow=false">
    <div class="popup-wrap">
      <div class="popup-content">
        <div class="popup-title" v-if="serialList.length>1">请选择意向车系</div>
        <div class="popup-title" v-else>是否领取该车系优惠券？</div>
        <div class="popup-save">
          <div class="select" @click="handlerSelectShow" :class="[serialList.length>1?'select-bg':'']">{{serial.name}}</div>
          <van-checkbox checked-color="#f2a346" label-disabled="true" v-model="checked" shape="square" v-if="isShow">
            <span @click="jumpUrl">我已阅读并同意隐私政策</span>
          </van-checkbox>
          <button type="button" name="button" class="get-btn" @click="receiveCoupon">立即领取</button>
        </div>
      </div>
    </div>
    <div @click="close" class="popup-close"></div>
  </van-popup>
  <van-popup v-model="tipShow" class="popup" :close-on-click-overlay="false" @click-overlay="closeTip">
    <div class="popup-wrap">
      <div class="popup-content">
        <div class="tip-title">领取成功优惠券可在卡包查看</div>
        <div class="tip-close" @click="closeTip">知道了</div>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
import {
  getActivitySerialList,
  receiveCoupon
} from 'common/js/api'
import {
  getQueryString
} from 'common/js/util'
export default {
  name: 'receive-coupon',
  data() {
    return {
      showPopup: true,
      selectShow: false,
      tipShow: false,
      coupon: {},
      serial: {},
      noSerial: {
        name: '请选择意向车系'
      },
      serialList: [],
      type: 0,
      checked: true,
      isShow: false
    }
  },
  watch: {
    showPopup(val) {
      if (!val) {
        this.selectShow = false
      }
    }
  },
  methods: {
    jumpUrl() {
      ap.pushWindow(`https://cat.pangku.com/static/agreement/index.html`)
    },
    close() {
      this.showPopup = false
      this.selectShow = false
    },

    handlerSelectShow() {
      this.selectShow = !this.selectShow
      if (this.selectShow && this.$refs.picker) {
        this.$nextTick(() => {
          this.$refs.picker.setIndexes([0])
        })
      }
    },
    clickCoupon(coupon, type) {
      this.coupon = coupon
      this.type = type
      let couponCount = this.$storejs.get(`${this.$key}CouponCount`) || 0
      if (this.coupon.is_client === 1) {
        this.$toast('请勿重复领取')
      } else if (couponCount >= 3) {
        this.$toast('最多领取3张优惠券')
      } else {
        this.getSerialList()
      }
    },
    onChangeSelect(vm, val) {
      this.serial = val
    },
    async getSerialList() {
      const res = await getActivitySerialList.call(this, this.$key, this.coupon.id)
      if (res.code === 0) {
        const list = res.data.list
        this.isShow = res.data.isShow
        if (list.length === 1) {
          this.serial = list[0]
          this.serialList = [...list]
        } else {
          this.serial = this.noSerial
          this.serialList = [...[this.noSerial], ...list]
        }
        this.showPopup = true
      } else {
        this.$toast(res.msg)
      }
    },
    receiveCoupon(coupon) {
      if (this.isShow && !this.checked) {
        this.$toast('需勾选须知说明才能领优惠券哦~')
        return
      }
      if (!this.serial.id) {
        this.$toast('车系不能为空')
        return
      }
      receiveCoupon
        .call(this, {
          baseURL: this.$baseURL.cat,
          url: `/coupon/${this.$key}/alipay`,
          data: {
            uid: this.$state.authInfo.uid,
            coupon: this.coupon,
            serial: this.serial,
            city: this.$state.city
          },
          params: {
            mid: getQueryString('mid'),
            type: this.type
          }
        })
        .then(res => {
          if (res.success === true) {
            this.$toast('领取成功，请到支付宝卡包查看')
            this.tipShow = true
            this.coupon.is_client = 1
            this.showPopup = false
            this.selectShow = false
            // 限制领取优惠券
            let couponCount = this.$storejs.get(`${this.$key}CouponCount`) || 0
            couponCount++
            this.$storejs.set(`${this.$key}CouponCount`, couponCount)
            if(this.$state.surveyShow){
              this.$state.surveyShow = false
              this.$storejs.set(`${this.$key}Alert`,true)
            }
          } else {
            this.$toast(res.error_msg)
          }
        })
    },
    closeTip() {
      this.tipShow = false
    }

  }
}
</script>

<style lang="scss" scoped>

.receive-coupon {
    .receive-popup {
        top: 30%;
    }
    .tip-close {
        width: 280px;
        height: 70px;
        line-height: 70px;
        border-radius: 35px;
        background: #ffb033;
        font-size: 30px;
        color: #fff;
        margin: 0 auto 30px;
    }
    .tip-title {
        color: #fff;
        font-size: 32px;
        margin: 80px auto;
    }
    .popup {
        .get-btn {
            width: 280px;
            text-align: center;
            line-height: 70px;
            border-radius: 38px;
            border: 0;
            background: #ffb033;
            color: #fff;
            font-size: 30px;
            margin: 40px auto;
        }
        .popup-wrap {
            padding: 20px;
        }
        .popup-title{
          height:80px;
          line-height: 60px;
          text-align: center;
          color:#fff;
          font-size: 30px;
          margin:30px auto;
        }
        .popup-content {
            position: relative;
            width: 600px;
            margin: 0 auto;
            border-radius: 25px;
            text-align: center;
            background: #e66f62;
            border: 10px solid #eab299;
            .big-title {
               font-size: 30px;
               margin:30px auto;
            }
            .select.select-bg {
                background: url("../../img/select-bg.png") #e35148 no-repeat 400px center;
                background-size: 40px 40px;
            }
            .van-checkbox {
                margin: 20px auto 0;
            }
            .select {
                background: #e35148;
                color: #fff;
                width: 460px;
                height: 70px;
                line-height: 70px;
                margin: 0 auto;
                padding-left: 20px;
                box-sizing: border-box;
                font-size: 30px;
                border-radius: 5px;
                text-align: left;
            }
        }
    }
}
</style>
